import React, { useEffect, useState } from 'react';
// import WrapArrow from '../../assets/wrap-arrow.svg';
import {ReactComponent as WrapArrow} from '../../assets/wrap-arrow.svg';
import { Button } from '../../components/Button';
import { getLocalUTCDate } from '../../helpers';
import OutsideClickHandler from 'react-outside-click-handler';
import { useDispatch } from 'react-redux';
import { handOver, returnFromOffice } from '../../redux/officeSlice';

const DebtItem = ({id, cityUTC, worker, selected, select, handOver, date}) => {

  const formatDate = getLocalUTCDate(cityUTC, date)
    return (
      <div className={`debts__item ${selected ? 'selected' : ''}`} onClick={select}>
        <div>id{id}</div>
        <div>{worker?.fullname || 'Нет мастера'}</div>
        <div><b>{handOver.toLocaleString('fr-FR')} ₽</b></div>
        <div>{formatDate}</div>
      </div>
    )
}

const HistoryItem = ({id, cityUTC, initiator, selected, select, handOver, date}) => {

  const formatDate = getLocalUTCDate(cityUTC, date)
    return (
      <div className={`debts__item ${selected ? 'selected' : ''}`} onClick={select}>
        <div>id{id}</div>
        <div>{initiator.fullname}</div>
        <div><b>{handOver.toLocaleString('fr-FR')} ₽</b></div>
        <div>{formatDate}</div>
      </div>
    )
}

export const Debts = ({orders, revenues, month, error}) => {
  
  const dispatch = useDispatch();
    const [isOpened, setOpen] = useState(false);

    const closeDebtsHandler = () => {
      if (!isOpened) return;
      setOpen(false);
    }

    const historyList = revenues.filter(r => r.order);

    const [selected, select] = useState([]);
    const [selectedHistory, selectHistory] = useState([]);

    const createSelectDebtHandler = (id) => () => {
      if (selected.some(d => d === id)) {
        select(selected.filter(s => s !== id));
        return;
      }
      select([...selected, id]);
    }
    const createSelectHistoryHandler = (id) => () => {
      if (selectedHistory.some(d => d === id)) {
        selectHistory(selectedHistory.filter(s => s !== id));
        return;
      }
      selectHistory([...selectedHistory, id]);
    }

    const selectUnselectAllHandler = () => {
      selected.length === orders.length
      ? select([])
      : select(orders.map(o => o._id))
    }
    const selectUnselectAllHistoryHandler = () => {
      selectedHistory.length === historyList.length
      ? selectHistory([])
      : selectHistory(historyList.map(r => r._id))
    }
    const [isButtonDisabled, setButtonDisabled] = useState(false);
    const enableButton = () => setButtonDisabled(false);
    const resetFunc = () => {
      select([]);
    }
    const resetReturnFunc = () => {
      selectHistory([]);
    }

    useEffect(() => {
      select([]);
      selectHistory([]);
    }, [month])

    const handOverOrder = () => {
      if (!selected.length) return;
      setButtonDisabled(true);
      dispatch(handOver({orderIds: selected, resetFunc, enableButton}));
      select([]); 
    }

    const returnFromOfficeHandler = () => {
      if (!selected.length) return;
      setButtonDisabled(true);
      dispatch(returnFromOffice({revenueIds: selectedHistory, resetFunc: resetReturnFunc, enableButton}));
      selectHistory([]);
    }

    const [isHistory, setHistory] = useState(false);

    const toHandOverAmount = orders.filter(o => selected.some(el => el === o._id)).reduce((total, cur) => total + cur.handOver, 0)
    const toReturnAmount = historyList.filter(r => selectedHistory.some(el => el === r._id)).reduce((total, cur) => total + cur.amount, 0)
    
    return (
        <OutsideClickHandler onOutsideClick={closeDebtsHandler}>
          <div className={`office__debts debts ${isOpened ? 'opened' : ''}`}>
            <div className="debts__header">
              <div className="debts__title">{isHistory ? 'История' : 'Долги'}</div>
            </div>
    
            <div className="debts__body">

            {isHistory ? <>
              {historyList.length ? <><div className="debts__item-titles">
                <div>id</div>
                <div>Сдал</div>
                <div>Сумма</div>
                <div>Дата</div>
              </div>
              <div className="debts__list">
                {historyList.sort((a,b) => b.details.handOver.by.fullname.localeCompare(a.details.handOver.by.fullname)).map((r) => 
                  <HistoryItem 
                    key={r._id} 
                    id={r.order.id}
                    cityUTC={r.city.UTC}
                    initiator={r.details.handOver.by}
                    handOver={r.amount}
                    selected={selectedHistory.some(d => d === r._id)}
                    select={createSelectHistoryHandler(r._id)}
                    date={r.details.handOver.at}
                />)}
              </div></> : <div className='no-items'>{error || 'История пуста'}</div>}
            </> : <>
            {orders.length ? <><div className="debts__item-titles">
                <div>id</div>
                <div>Мастер</div>
                <div>К сдаче</div>
                <div>Дата</div>
              </div>
              <div className="debts__list">
                {orders.sort((a,b) => b.worker?.fullname.localeCompare(a.worker?.fullname)).map((order) => 
                  <DebtItem 
                    key={order._id} 
                    id={order.id}
                    cityUTC={order.city.UTC}
                    worker={order.worker}
                    handOver={order.handOver}
                    selected={selected.some(d => d === order._id)}
                    select={createSelectDebtHandler(order._id)}
                    date={order.completionDate}
                />)}
              </div></> : <div className='no-items'>{error || 'Нет долгов'}</div>}
            </>}

            </div>
            <div className="debts__footer">
              <div className="debts__select-info">
                {isHistory ? 'К возврату' : 'К переводу'}: {isHistory ? toReturnAmount : toHandOverAmount} ₽
              </div>
              <div className="debts__footer-buttons">
                <Button text={isHistory ? 'долги' : 'история'} onClick={() => setHistory(prev => !prev)}/>
                <Button text='все/сброс' onClick={isHistory ? selectUnselectAllHistoryHandler : selectUnselectAllHandler}/>
                <Button text={isHistory ? 'вернуть' : 'сдать'} disabled={isButtonDisabled} onClick={isHistory ? returnFromOfficeHandler : handOverOrder}/>
              </div>
            </div>
            <div className="wrap-button" onClick={() => setOpen(prev => !prev)}>
                <WrapArrow />
            </div>
        </div>
          </OutsideClickHandler>
    );
};
